import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { partnerApiPaths } from "api/apiPaths";
import client from "api/client";
import { PartnerRequestModel } from "./model/PartnerRequestModel";
import { PartnerResponseModel } from "./model/PartnerResponseModel";
import { PartnerCreateActionRequestModel } from "./model/actions/createAction/PartnerCreateActionRequestModel";
import { PartnerUpdateActionRequestModel } from "./model/actions/updateAction/PartnerUpdateActionRequestModel";
import { PartnerDetailResponseModel } from "./model/detail/PartnerDetailResponseModel";

export interface IPartnerRepository {
  getList(
    params: PartnerRequestModel
  ): Promise<BaseApiResponseModel<PartnerResponseModel[]>>;

  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerDetailResponseModel>>;

  createPartner(
    body: PartnerCreateActionRequestModel
  ): Promise<BaseApiResponseModel<PartnerResponseModel>>;

  updatePartner(
    body: PartnerUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<PartnerRequestModel>>;

  deletePartner(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerResponseModel>>;
}

class PartnerManagementImpl implements IPartnerRepository {
  async getList(
    params: PartnerRequestModel
  ): Promise<BaseApiResponseModel<PartnerResponseModel[]>> {
    return await client?.get(partnerApiPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerDetailResponseModel>> {
    return await client?.get(partnerApiPaths?.DETAIL, params);
  }

  async createPartner(
    body: PartnerCreateActionRequestModel
  ): Promise<BaseApiResponseModel<PartnerResponseModel>> {
    return await client?.post(partnerApiPaths?.CREATE, body);
  }

  async updatePartner(
    body: PartnerUpdateActionRequestModel
  ): Promise<BaseApiResponseModel<PartnerRequestModel>> {
    return await client?.put(partnerApiPaths?.UPDATE, body);
  }

  async deletePartner(params: {
    code: string;
  }): Promise<BaseApiResponseModel<PartnerResponseModel>> {
    return await client?.delete(partnerApiPaths?.DELETE, params);
  }
}

export const defaultPartnerManagement = new PartnerManagementImpl();
